<template>
  <datepicker
    @input="handleInput"
    @focus="setupDateInputMask"
    :format="'DD/MM/YYYY'"
    :lang="ptBR"
    :value-type="'YYYY-MM-DD'"
    :input-attr="{ placeholder: 'Data de Nascimento' }"
    class="date-input"
    clearable
    editable
    v-model="localValue"
  />
</template>

<script>
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    Datepicker,
  },

  props: {
    value: {
      default: null,
    },
  },

  data() {
    return {
      localValue: this.value,

      ptBR: {
        formatLocale: {
          firstDayOfWeek: 1,

          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],

          monthsShort: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],

          weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
          weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
          weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        },

        yearFormat: "YYYY",
        monthFormat: "MM",
        monthBeforeYear: false,
        format: "DD/MM/YYYY",
        valueType: "YYYY-MM-DD",
      },
    };
  },

  methods: {
    setupDateInputMask(event) {
      const input = event.target;

      if (!input) return;

      input.removeEventListener("input", this.handleDateInput);

      input.addEventListener("input", this.handleDateInput);
    },

    handleDateInput(event) {
      let value = event.target.value.replace(/\D/g, "");

      if (value.length > 0) {
        if (value.length <= 2) {
          event.target.value = value;
        } else if (value.length <= 4) {
          event.target.value = value.slice(0, 2) + "/" + value.slice(2);
        } else {
          event.target.value =
            value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4, 8);
        }
      }
    },

    handleInput(event) {
      this.$emit("input", event);
    },
  },
};
</script>

<style lang="scss" scoped></style>
